import * as React from 'react'
import PropTypes from 'prop-types'
import { ContentWrapper, Headline, Description } from './styles'

export function HeroHeader({ headingCopy, subHeadlineCopy }) {
  return (
    <ContentWrapper>
      <Headline>{headingCopy}</Headline>
      <Description>{subHeadlineCopy}</Description>
    </ContentWrapper>
  )
}

HeroHeader.propTypes = {
  headingCopy: PropTypes.string.isRequired,
  subHeadlineCopy: PropTypes.string.isRequired,
}
